<!-- <div id='mediaspace{{id}}'></div> -->
<video id='videoElement{{id}}' controls style="width: -webkit-fill-available;"></video>